/**
 * @module
 * @name smDevModal
 * @description Shows modal if resolution is less than 1024
 */
export default {
  name: 'smDevModal'
}
